/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BackfillConfig } from './BackfillConfig';
import {
    BackfillConfigFromJSON,
    BackfillConfigFromJSONTyped,
    BackfillConfigToJSON,
} from './BackfillConfig';
import type { DynamicMappingsInputEntry } from './DynamicMappingsInputEntry';
import {
    DynamicMappingsInputEntryFromJSON,
    DynamicMappingsInputEntryFromJSONTyped,
    DynamicMappingsInputEntryToJSON,
} from './DynamicMappingsInputEntry';
import type { RawFilter } from './RawFilter';
import {
    RawFilterFromJSON,
    RawFilterFromJSONTyped,
    RawFilterToJSON,
} from './RawFilter';
import type { ReadFilter } from './ReadFilter';
import {
    ReadFilterFromJSON,
    ReadFilterFromJSONTyped,
    ReadFilterToJSON,
} from './ReadFilter';
import type { SelectedFieldsAutoConfig } from './SelectedFieldsAutoConfig';
import {
    SelectedFieldsAutoConfigFromJSON,
    SelectedFieldsAutoConfigFromJSONTyped,
    SelectedFieldsAutoConfigToJSON,
} from './SelectedFieldsAutoConfig';

/**
 * 
 * @export
 * @interface ReadConfigObject
 */
export interface ReadConfigObject {
    /**
     * The name of the object to read from.
     * @type {string}
     * @memberof ReadConfigObject
     */
    objectName: string;
    /**
     * The schedule for reading the object, in cron syntax.
     * @type {string}
     * @memberof ReadConfigObject
     */
    schedule?: string;
    /**
     * If this flag is set to true, scheduled reads associated with this object will be paused, and on-demand reads will not be allowed.
     * @type {boolean}
     * @memberof ReadConfigObject
     */
    disabled?: boolean;
    /**
     * The name of the destination that the result should be sent to.
     * @type {string}
     * @memberof ReadConfigObject
     */
    destination?: string;
    /**
     * This is a map of field names to booleans indicating whether they should be read. If a field is already included in `selectedFieldMappings`, it does not need to be included here.
     * @type {{ [key: string]: boolean; }}
     * @memberof ReadConfigObject
     */
    selectedFields: { [key: string]: boolean; };
    /**
     * This is a map of field names to their value mappings.
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof ReadConfigObject
     */
    selectedValueMappings?: { [key: string]: { [key: string]: string; }; };
    /**
     * An array containing all available dynamic field and value mappings for this installation, provided by the InstallIntegration component. This array represents the complete set of possible mappings, regardless of which ones are currently selected. The actual selected mappings are stored separately in the selectedFieldMappings property.
     * @type {Array<DynamicMappingsInputEntry>}
     * @memberof ReadConfigObject
     */
    dynamicMappingsInput?: Array<DynamicMappingsInputEntry>;
    /**
     * This is a map of mapToNames to field names. (A mapTo name is the name the builder wants to map a field to when it lands in their destination.)
     * @type {{ [key: string]: string; }}
     * @memberof ReadConfigObject
     */
    selectedFieldMappings: { [key: string]: string; };
    /**
     * 
     * @type {SelectedFieldsAutoConfig}
     * @memberof ReadConfigObject
     */
    selectedFieldsAuto?: SelectedFieldsAutoConfig;
    /**
     * 
     * @type {BackfillConfig}
     * @memberof ReadConfigObject
     */
    backfill?: BackfillConfig;
    /**
     * Filters to apply when reading records during incremental reads and backfill. Multiple conditions are joined by AND. Each field can only have one condition.
     * @type {Array<ReadFilter>}
     * @memberof ReadConfigObject
     */
    fieldFilters?: Array<ReadFilter>;
    /**
     * 
     * @type {RawFilter}
     * @memberof ReadConfigObject
     */
    rawFilter?: RawFilter;
}

/**
 * Check if a given object implements the ReadConfigObject interface.
 */
export function instanceOfReadConfigObject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectName" in value;
    isInstance = isInstance && "selectedFields" in value;
    isInstance = isInstance && "selectedFieldMappings" in value;

    return isInstance;
}

export function ReadConfigObjectFromJSON(json: any): ReadConfigObject {
    return ReadConfigObjectFromJSONTyped(json, false);
}

export function ReadConfigObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadConfigObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectName': json['objectName'],
        'schedule': !exists(json, 'schedule') ? undefined : json['schedule'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'destination': !exists(json, 'destination') ? undefined : json['destination'],
        'selectedFields': json['selectedFields'],
        'selectedValueMappings': !exists(json, 'selectedValueMappings') ? undefined : json['selectedValueMappings'],
        'dynamicMappingsInput': !exists(json, 'dynamicMappingsInput') ? undefined : ((json['dynamicMappingsInput'] as Array<any>).map(DynamicMappingsInputEntryFromJSON)),
        'selectedFieldMappings': json['selectedFieldMappings'],
        'selectedFieldsAuto': !exists(json, 'selectedFieldsAuto') ? undefined : SelectedFieldsAutoConfigFromJSON(json['selectedFieldsAuto']),
        'backfill': !exists(json, 'backfill') ? undefined : BackfillConfigFromJSON(json['backfill']),
        'fieldFilters': !exists(json, 'fieldFilters') ? undefined : ((json['fieldFilters'] as Array<any>).map(ReadFilterFromJSON)),
        'rawFilter': !exists(json, 'rawFilter') ? undefined : RawFilterFromJSON(json['rawFilter']),
    };
}

export function ReadConfigObjectToJSON(value?: ReadConfigObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objectName': value.objectName,
        'schedule': value.schedule,
        'disabled': value.disabled,
        'destination': value.destination,
        'selectedFields': value.selectedFields,
        'selectedValueMappings': value.selectedValueMappings,
        'dynamicMappingsInput': value.dynamicMappingsInput === undefined ? undefined : ((value.dynamicMappingsInput as Array<any>).map(DynamicMappingsInputEntryToJSON)),
        'selectedFieldMappings': value.selectedFieldMappings,
        'selectedFieldsAuto': SelectedFieldsAutoConfigToJSON(value.selectedFieldsAuto),
        'backfill': BackfillConfigToJSON(value.backfill),
        'fieldFilters': value.fieldFilters === undefined ? undefined : ((value.fieldFilters as Array<any>).map(ReadFilterToJSON)),
        'rawFilter': RawFilterToJSON(value.rawFilter),
    };
}

